import { render, staticRenderFns } from "./PointSale.vue?vue&type=template&id=21b69b11&"
import script from "./PointSale.vue?vue&type=script&lang=js&"
export * from "./PointSale.vue?vue&type=script&lang=js&"
import style0 from "./PointSale.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports